define('pubsub/vimeo',[
    'jquery',
    'underscore',
    '_pubsub'
], function($,_,Pubsub)
{
    'use strict';
    
    return function()
    {
        this.options={
            script:'https://player.vimeo.com/api/player.js'
        };
        
        var oPubsub=new Pubsub();
        
        this.init=function()
        {
            this.aVideo=[];
            oPubsub.on(Pubsub.CREATE_VIMEO_PLAYER, _.bind(this.triggerCeate,this));
            oPubsub.on(Pubsub.PLAY_VIDEO,_.bind(this.pauseAll,this));
        };
        
        this.triggerCeate=function(ev)
        {
            oPubsub.trigger(Pubsub.PLAY_VIDEO, ev.data('id'));
            this.require().done(_.bind(this.create,this,ev));
        };
        
        this.create=function(ev)
        {
            var id=ev.data('id'),
                    $el=$('<div/>', {
                        id:id,
                        'class':ev.data('class')
                    }).insertAfter(ev);
            
            var oPlayer=new this.player($el[0], {
                id:ev.data('video-id'),
                width:'100%',
                //@see FDZ-642: disable autoplay
                autoplay:false
            });
            oPlayer.on('play', _.partial(this.broadcastPlay,id));
            this.aVideo.push({
                id:id,
                player:oPlayer
            });
        };
        
        this.require=function()
        {
            var def=new $.Deferred();

            if(typeof Vimeo==='undefined') {
                require([this.options.script], _.bind(function(vimeo){
                    this.player=vimeo;
                    def.resolve();
                },this));
            } else {
                def.resolve();
            }

            return def.promise();
        };
        
        this.pauseAll=function(id)
        {
            _.each(this.aVideo, _.bind(function(item){
                if(id!==item.id) {
                    this.pause(item);
                }
            },this));
        };
        
        this.pause=function(item)
        {
            item.player.pause();
        };
        
        this.broadcastPlay=function(id)
        {
            oPubsub.trigger(Pubsub.PLAY_VIDEO,id);
        };
        
        this.init();
    };
});
